import React from "react";
import { useRoutes } from "react-router-dom";
import { permissonRouters, commonRouters } from "./common/routes";
import MainLayout from "./layout/mainLayout";
import QiankunMainLayout from "./layout/QiankunLayout";
import { useRecoilValue } from "recoil";
import { permissionCodeObj } from "./recoil/account";
import NoPermission from "@/views/exception/403";
import { authGuard } from "./gs-utils/core/utils/routeGuard";

export function GlobalRoutes() {
  const permissions = useRecoilValue(permissionCodeObj);

  const routes = authGuard({
    permissions,
    permissonRouters,
    commonRouters,
    NoPermission: <NoPermission />,
  });

  const globalRoutes = useRoutes([
    {
      path: "/",
      element: window.__POWERED_BY_QIANKUN__ ? (
        <QiankunMainLayout />
      ) : (
        <MainLayout />
      ),
      children: routes,
    },
  ]);

  return globalRoutes;
}
